
/*
 * ! @chakra-ui/vue v0.11.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

import { g as get, d as addOpacity, j as generateAlphas } from './index-4e48fa90.js';

var solidStyle = function solidStyle(ref) {
  var colors = ref.theme.colors;
  var color = ref.color;

  var _color = colors[color] && colors[color][500];

  var darkModebackgroundColor = addOpacity(_color, 0.6);
  return {
    light: {
      backgroundColor: get(color, 500),
      color: 'white'
    },
    dark: {
      backgroundColor: darkModebackgroundColor,
      color: 'whiteAlpha.800'
    }
  };
};

var subtleStyle = function subtleStyle(ref) {
  var colors = ref.theme.colors;
  var color = ref.color;

  var _color = colors[color] && colors[color][200];

  var alphaColors = generateAlphas(_color);
  var darkModebackgroundColor = alphaColors[300];
  return {
    light: {
      backgroundColor: get(color, 100),
      color: get(color, 800)
    },
    dark: {
      backgroundColor: darkModebackgroundColor,
      color: get(color, 200)
    }
  };
};

var outlineStyle = function outlineStyle(ref) {
  var colors = ref.theme.colors;
  var color = ref.color;

  var _color = colors[color] && colors[color][200];

  var darkModeColor = addOpacity(_color, 0.8);
  var boxShadowColor = colors[color] && colors[color][500];
  return {
    light: {
      boxShadow: 'inset 0 0 0px 1px ' + boxShadowColor,
      color: get(color, 500)
    },
    dark: {
      boxShadow: 'inset 0 0 0px 1px ' + darkModeColor,
      color: darkModeColor
    }
  };
};

var variantProps = function variantProps(props) {
  var variant = props.variant;
  var colorMode = props.colorMode;

  switch (variant) {
    case 'solid':
      return solidStyle(props)[colorMode];

    case 'subtle':
      return subtleStyle(props)[colorMode];

    case 'outline':
      return outlineStyle(props)[colorMode];

    default:
      return {};
  }
};

var useBadgeStyle = function useBadgeStyle(props) {
  return variantProps(props);
};

export { useBadgeStyle as u };
